module.exports = __webpack_public_path__ + "img/header-wb.75fea262.jpg";